export default __webpack_public_path__ + "static/media/rovatti 1.b3ca51ed.png";